export default function CsharpArithmeticOperators() {
  return (
    <h2>Csharp Arithmetic Operators</h2>
  );
}
